import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {SILENT_ERROR_HEADER} from '../_helpers/silent-error';
import {Observable} from 'rxjs';

@Injectable()
export class ProjectService {
  constructor(private http: HttpClient) {
  }

  show(id) {
    return this.http.get<any>(`${environment.apiUrl}/project/show/${id}`);
  }

  canEditProject(id) {
    return this.http.get<any>(`${environment.apiUrl}/project/can-edit-project/${id}`);
  }

  showParentProjects() {
    return this.http.get<any>(`${environment.apiUrl}/project/show-parent-projects`);
  }

  showSimple(id) {
    return this.http.get<any>(`${environment.apiUrl}/project/show-simple/${id}`);
  }

  storeProjectType(projectType) {
    return this.http.post<any>(`${environment.apiUrl}/project/project-type`, projectType);
  }

  update(client) {
    return this.http.put<any>(`${environment.apiUrl}/client/${client.id}`, client);
  }

  delete(id: number) {
    return this.http.delete<any>(`${environment.apiUrl}/client/${id}`);
  }

  index(page, orderColumn, orderAsc, tab: any = '', dateFrom = null, dateTo = null, admin_ids = null, project_type_ids = null, name = '', submissionDate = null, selectedDepartments = '', show_only_pending_missions = false, splitByDate = false) {
    let orderString = '';
    let nameString = '';
    let submissionDateString = '';
    let selectedDepartmentsString = '';

    if (orderColumn) {
      const direction = orderAsc ? 'asc' : 'desc';
      orderString = '&order_by=' + orderColumn + '&direction=' + direction;
    }

    if (name && name.length > 0) {
      nameString = '&name=' + name;
    }

    if (dateFrom) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateFrom)) {
        dateFrom = dateFrom.getFullYear() + '-' + this.padMonthDay(dateFrom.getMonth() + 1) + '-' + this.padMonthDay(dateFrom.getDate());
      }
    } else {
      dateFrom = '';
    }
    
    if (dateTo) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateTo)) {
        dateTo = dateTo.getFullYear() + '-' + this.padMonthDay(dateTo.getMonth() + 1) + '-' + this.padMonthDay(dateTo.getDate());
      }
    } else {
      dateTo = '';
    }
    
    let dateFromString = dateFrom ? '&from=' + dateFrom : '';
    let dateToString = dateTo ? '&to=' + dateTo : '';
    
    if (submissionDate) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(submissionDate)) {
        submissionDate = submissionDate.getFullYear() + '-' + this.padMonthDay(submissionDate.getMonth() + 1) + '-' + this.padMonthDay(submissionDate.getDate());
      }
      submissionDateString = '&submissionDate=' + submissionDate;
    } else {
      submissionDateString = '';
    }

    if (selectedDepartments && selectedDepartments.length > 0) {
      selectedDepartmentsString = '&selectedDepartments=' + selectedDepartments;
    }

    let show_only_pending_missions_string = '';
    if (show_only_pending_missions) {
      show_only_pending_missions_string = '&show_only_pending_missions=' + show_only_pending_missions;
    }

    if (!admin_ids) admin_ids = '';
    if (!project_type_ids) project_type_ids = '';
    // JS-1704: several dashboard tabs at once go out as `tabs=`, which the api prefers over
    // the single-tab `tab=`. A plain string still sends `tab=`, so the other callers of this
    // method are untouched.
    const tabString = Array.isArray(tab) ? `&tabs=${tab.join(',')}` : `&tab=${tab}`;
    // JS-1704: one row per project date, figures read from project_date_data.
    const splitString = splitByDate ? '&split=1' : '';
    return this.http.get<any>(`${environment.apiUrl}/project?page=${page + orderString + nameString + dateFromString + dateToString + submissionDateString + selectedDepartmentsString}${tabString}&admin_ids=${admin_ids}&project_type_ids=${project_type_ids}${show_only_pending_missions_string}${splitString}`);
  }
  
  countProjects(dateFrom = null, dateTo = null, admin_ids = null, project_type_ids = null, show_only_pending_missions = false) {
    if (dateFrom) {
      dateFrom = dateFrom.getFullYear() + '-' + this.padMonthDay(dateFrom.getMonth() + 1) + '-' + this.padMonthDay(dateFrom.getDate());
    } else {
      dateFrom = '';
    }
    if (dateTo) {
      dateTo = dateTo.getFullYear() + '-' + this.padMonthDay(dateTo.getMonth() + 1) + '-' + this.padMonthDay(dateTo.getDate());
    } else {
      dateTo = '';
    }

    if (!admin_ids) admin_ids = '';
    if (!project_type_ids) project_type_ids = '';

    let show_only_pending_missions_string = '';
    if (show_only_pending_missions) {
      show_only_pending_missions_string = '&show_only_pending_missions=' + show_only_pending_missions;
    }
    return this.http.get<any>(`${environment.apiUrl}/project/count-projects?from=${dateFrom}&to=${dateTo}&admin_ids=${admin_ids}&project_type_ids=${project_type_ids}${show_only_pending_missions_string}`);
  }

  getProjectsByType(type, dateFrom = null, dateTo = null, admin_ids = null, project_type_ids = null, page = 1,  orderColumn = null, orderAsc = null, name = null , show_only_pending_missions = false) {
    let orderString = '';
    let nameString = '';

    if (orderColumn) {
      const direction = orderAsc ? 'asc' : 'desc';
      orderString = '&order_by=' + orderColumn + '&direction=' + direction;
    }

    if (name.length > 0) {
      nameString = '&name=' + name;
    }
    
    if (dateFrom) {
      dateFrom = dateFrom.getFullYear() + '-' + this.padMonthDay(dateFrom.getMonth() + 1) + '-' + this.padMonthDay(dateFrom.getDate());
    } else {
      dateFrom = '';
    }
    if (dateTo) {
      dateTo = dateTo.getFullYear() + '-' + this.padMonthDay(dateTo.getMonth() + 1) + '-' + this.padMonthDay(dateTo.getDate());
    } else {
      dateTo = '';
    }

    let show_only_pending_missions_string = '';
    if (show_only_pending_missions) {
      show_only_pending_missions_string = '&show_only_pending_missions=' + show_only_pending_missions;
    }

    if (!admin_ids) admin_ids = '';
    return this.http.get<any>(`${environment.apiUrl}/project/type?page=${page + orderString + nameString}&type=${type}&from=${dateFrom}&to=${dateTo}&admin_ids=${admin_ids}${show_only_pending_missions_string}`);
  }

  store(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/store`, param);
  }

  storeProjectExtrars(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/extras`, param);
  }

  storeAllocationExtrars(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/allocation-extras`, param);
  }

  getLocationsApi(param) {
    const url = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=' +
      param + '&types=geocode&key=AIzaSyBM-5MzyZoh0hCJJtU0JrJCvcSbQR1f_44';

    return this.http.get(url);
  }

  placeDetailsApi(placeId): Observable<any> {
    const url = 'https://maps.googleapis.com/maps/api/place/details/json?placeid='
      + placeId + '&key=AIzaSyBM-5MzyZoh0hCJJtU0JrJCvcSbQR1f_44';
    return this.http.get(url, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    });
  }

  getLocationsDB(param) {
    return this.http.get<any>(`${environment.apiUrl}/project/search-location?search=${param}`);
  }

  getLocationsGoogelMaps(param) {
    return this.http.post<any>(`${environment.apiUrl}/get-location-google-maps`, param);
  }

  storeLocation(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/storeLocation`, param);
  }

  storeClient(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/client`, param);
  }

  storeContact(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/contact`, param);
  }

  removeImage(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/image/remove`, param);
  }

  deleteLocationDate(id) {
    return this.http.delete<any>(`${environment.apiUrl}/project/delete-location-date/${id}`);
  }

  // silent: no error toast per failing day (JS-1986 bulk remove reports one summary instead).
  doesProjectLocationDateHaveAllocations(id, silent = false) {
    const options = silent ? {headers: new HttpHeaders({[SILENT_ERROR_HEADER]: '1'})} : {};
    return this.http.get<any>(`${environment.apiUrl}/project/does-project-location-date-have-allocations/${id}`, options);
  }

  deleteProject(id) {
    return this.http.delete<any>(`${environment.apiUrl}/project/delete/${id}`);
  }

  getPublishes(id) {
    return this.http.get<any>(`${environment.apiUrl}/project/publish/${id}`);
  }

  publishProject(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/publish`, param);
  }

  getSubmittedTimestamps(
    page = 1,
    orderColumn,
    orderAsc,
    search,
    from,
    to,
    status,
    managedProjects,
    isClient = false,
    selectedDepartments = '',
    searchProject?: string,
    searchEmployee?: string,
    searchRole?: string
  ) {
    let queryString = '';
    if (orderColumn) {
      const direction = orderAsc ? 'asc' : 'desc';
      queryString += '&order_by=' + encodeURIComponent(orderColumn) + '&direction=' + direction;
    }

    if (search) {
      const encodedSearch = encodeURIComponent(search);
      queryString += '&search=' + encodedSearch;
    }

    if (searchProject != null && searchProject !== undefined && searchProject !== '') queryString += '&search_project=' + encodeURIComponent(searchProject);
    if (searchEmployee != null && searchEmployee !== undefined && searchEmployee !== '') queryString += '&search_employee=' + encodeURIComponent(searchEmployee);
    if (searchRole != null && searchRole !== undefined && searchRole !== '') queryString += '&search_role=' + encodeURIComponent(searchRole);

    if (from) queryString += '&from=' + encodeURIComponent(from);

    if (to) queryString += '&to=' + encodeURIComponent(to);

    if (status) queryString += '&status=' + encodeURIComponent(status);

    if (isClient) queryString += '&is_client=' + isClient;
    if (selectedDepartments) queryString += '&selectedDepartments=' + encodeURIComponent(selectedDepartments);

    queryString += '&managed_projects=' + managedProjects;

    return this.http.get<any>(`${environment.apiUrl}/hire/submitted-timestamps?page=${page}${queryString}`);
  }

  padMonthDay(number) {
    if (number < 10) {
      return '0' + number;
    } else {
      return number;
    }
  }

  getAgencyLogoPath(id) {
      return this.http.get<any>(`${environment.apiUrl}/agency/logo/${id}`);
  }

  cancelProject(id) {
      return this.http.delete<any>(`${environment.apiUrl}/project/cancel/${id}`);
  }

  generatePastJobsXLSX(param) {
      return this.http.post<any>(`${environment.apiUrl}/hire/generate-xlsx`, param);
  }

  exportWorkValidationDashboardAsXLSX(orderColumn, orderAsc, search, from, to, status, type = 'agency', managedProjects = true, selectedIds = []) {
      let queryString = '';
      if (orderColumn) {
          const direction = orderAsc ? 'asc' : 'desc';
          queryString += '&order_by=' + orderColumn + '&direction=' + direction;
      }

      if (from) queryString += '&from=' + from;

      if (to) queryString += '&to=' + to;

      if (status) queryString += '&status=' + status;

      if (type) queryString += '&type=' + type;

      queryString += '&managed_projects=' + managedProjects;

      if (selectedIds && selectedIds.length > 0) queryString += '&allocation_ids=' + selectedIds.join(',');

      return this.http.get<any>(`${environment.apiUrl}/hire/export-submitted-timestamps?search=${search + queryString}`);
  }

  exportWorkValidationEventsAsXLSX(orderColumn, orderAsc, search, from, to, status, type = 'agency', managedProjects = true, selectedIds = []) {
      let queryString = '';
      if (orderColumn) {
          const direction = orderAsc ? 'asc' : 'desc';
          queryString += '&order_by=' + orderColumn + '&direction=' + direction;
      }

      if (from) queryString += '&from=' + from;

      if (to) queryString += '&to=' + to;

      if (status) queryString += '&status=' + status;

      if (type) queryString += '&type=' + type;

      queryString += '&managed_projects=' + managedProjects;

      if (selectedIds && selectedIds.length > 0) queryString += '&allocation_ids=' + selectedIds.join(',');

      return this.http.get<any>(`${environment.apiUrl}/hire/export-work-validation-events?search=${search + queryString}`);
  }

  exportWorkValidationEventsAsync(body: any) {
      return this.http.post<any>(`${environment.apiUrl}/hire/export-work-validation-events-async`, body);
  }

  exportProjectCostOverview(id) {
      return this.http.get<any>(`${environment.apiUrl}/project/cost-overview/${id}`);
  }

  schedulePublication(param) {
    return this.http.post<any>(`${environment.apiUrl}/project/schedule-publication`, param);
  }

  getScheduledPublications(id) {
      return this.http.get<any>(`${environment.apiUrl}/project/scheduled-publications/${id}`);
  }

  checkIfClientUserHasAccessToThisOrder(id, respondAsError = false) {
    let respondAsErrorString = '';
    if(respondAsError){ 
      respondAsErrorString = '?respondAsError=' + respondAsError;
    }
    return this.http.get<any>(`${environment.apiUrl}/project/check-if-client-user-has-access-to-order/${id}${respondAsErrorString}`);
  }

  deleteScheduledPublication(scheduleId) {
      return this.http.delete<any>(`${environment.apiUrl}/project/scheduled-publications/${scheduleId}`);
  }

  checkIfProjectNumberExists(projectId, number) {
    return this.http.get<any>(`${environment.apiUrl}/project/number-exists/${projectId}/${number}`);
  }

  sendDataToClient(model){
    return this.http.post<any>(`${environment.apiUrl}/send-data-to-client`, model);
  }

  autoAssignMissions(id, params = null){
    return this.http.post<any>(`${environment.apiUrl}/project/auto-assign-missions/${id}`, params)
  }
  
  projectOrOrderOrigin(params){
    return this.http.post<any>(`${environment.apiUrl}/project/project-or-order-origin`, params)
  }
  
  getTimestampSupervisors(clientId) {
    return this.http.get<any>(`${environment.apiUrl}/project/timestamp-supervisors/${clientId}`);
  }
  
  getTimestampSupervisorProjects(params: { page; per_page; name }) {
    return this.http.get<any>(`${environment.apiUrl}/project/timestamp-supervisor-projects`, { params });
  }

  getTimestampSupervisorMissions(projectId, httpParams) {
    return this.http.get<any>(`${environment.apiUrl}/project/timestamp-supervisor-missions/${projectId}`, { params: httpParams });
  }

  getTimestampSupervisorMissionsData(projectId) {
    return this.http.get<any>(`${environment.apiUrl}/project/timestamp-supervisor-missions-data/${projectId}`);
  }

  addTimestampAsTimestampSupervisor(params) {
    return this.http.post<any>(`${environment.apiUrl}/project/add-timestamp-as-timestamp-supervisor`, params);
  }

  checkMissionConflictsForTheSelectedTimestamp(params) {
    return this.http.post<any>(`${environment.apiUrl}/project/check-mission-conflicts-for-the-selected-timestamp`, params);
  }

  saveRoleTariffGroup(roleId, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/save-role-tariff-group/${roleId}`, params);
  }

  getRolesWithTimestampSupervisorPrivilege() {
    return this.http.get<any>(`${environment.apiUrl}/project/roles-with-timestamp-supervisor-privilege`);
  }

  saveDepartment(id, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/save-department/${id}`, params);
  }
  storeSplitShifts(id, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/split-shifts/${id}`, params);
  }
  getSplitShifts(id) {
    return this.http.get<any>(`${environment.apiUrl}/project/get-split-shifts/${id}`);
  }

  updateProjectCostCenter(projectId, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/update-project-cost-center/${projectId}`, params);
  }

  updateProjectDepartment(projectId, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/update-project-department/${projectId}`, params);
  }

  saveRoleDepartment(roleId, params) {
    return this.http.post<any>(`${environment.apiUrl}/project/save-role-department/${roleId}`, params);
  }
}
